<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4 6.41A2.396 2.396 0 016.392 4h6.114a2.39 2.39 0 012.085 1.223l1.523 2.717c.06.107.174.174.298.174h9.196a2.396 2.396 0 012.392 2.4V25.6c0 1.325-1.071 2.4-2.392 2.4H6.466a2.396 2.396 0 01-2.392-2.39L4 6.41z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsFolderFilled'
}
</script>
